import { AutogenModelFedtaxtable, AutogenRowFedtaxtable } from "./autogen/AutogenModelFedtaxtable";

export class ModelFedtaxtable extends AutogenModelFedtaxtable<RowFedtaxtable> {
	constructor() {
		super(RowFedtaxtable);
	}
}

export class RowFedtaxtable extends AutogenRowFedtaxtable {
}